import { useEffect, useState } from "@wordpress/element";

import { __, _x } from "@wordpress/i18n";
import { useGeolocation } from "../services/geolocation.js";
import { useMapsLibrary } from "@vis.gl/react-google-maps";

export function Geolocator({ onChange, triggerOnLoad = false, ...props }) {
  const [geolocation, askGeolocation, canGeolocate] = useGeolocation();
  const [geocoder, setGeocoder] = useState(null);

  const geocoding = useMapsLibrary("geocoding");

  useEffect(
    function () {
      if (!geocoding) return;

      setGeocoder(new geocoding.Geocoder());
    },
    [geocoding]
  );

  useEffect(
    function () {
      if (!geocoder || !geolocation || !geolocation.data) return;

      const location = {
        lat: geolocation.data.coords.latitude,
        lng: geolocation.data.coords.longitude,
      };

      geocoder
        .geocode({ location })
        .then((response) => {
          if (response.results[0]) {
            onChange && onChange(response.results[0]);
          } else {
            onChange && onChange(`${location.lat},${location.lng}`);
          }
        })
        .catch((e) => console.error("Geocoder failed due to: " + e));
    },
    [geocoder, geolocation]
  );

  useEffect(
    function () {
      if (!triggerOnLoad) return;
      if (!canGeolocate) return;
      if (!askGeolocation) return;
      askGeolocation();
    },
    [askGeolocation, canGeolocate, triggerOnLoad]
  );

  if (!canGeolocate) return null;

  return (
    <button onClick={askGeolocation} {...props}>
      {_x("Me géolocaliser", "Frontend stores locator", "manitoba-stores")}
    </button>
  );
}
